// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PaymentLinks_Wrapper__kHi2l","Header":"PaymentLinks_Header__VghCA","Container":"PaymentLinks_Container__mXbB7"};